export var CommonPageNamesEnum;

(function (CommonPageNamesEnum) {
  /** System admin */
  CommonPageNamesEnum["Import"] = "SYSTEM-ADMIN-IMPORT-NAME";
})(CommonPageNamesEnum || (CommonPageNamesEnum = {}));